// Fabric.js canvas init
var canvas = this.__canvas = new fabric.Canvas('product-customize-canvas');
var mapctx = canvas.getContext('2d');
const fileInput = document.querySelector(".image_uploader_form");
const productSelection = document.querySelector(".customizer-action-wrapper select");

// function canvasResize() {
//     const defaultImage = document.querySelector(".product-customizer-wrapper .image-wrapper picture");
//     const canvasContainer = document.querySelector(".product-customizer-wrapper .canvas-container");

//     if (!defaultImage) return;

//     if (defaultImage.classList.contains("added_canvas") && canvasContainer) {
//         canvas.setWidth(canvasContainer.offsetWidth);
//         canvas.setHeight(canvasContainer.offsetHeight);
//     } else {
//         canvas.setWidth(defaultImage.offsetWidth);
//         canvas.setHeight(defaultImage.offsetHeight);
//     }
// }

function canvasResize() {
    const defaultImage = document.querySelector(".product-customizer-wrapper .image-wrapper picture");
    const canvasContainer = document.querySelector(".product-customizer-wrapper .canvas-container");

    if (!defaultImage) return;

    let width, height;

    if (defaultImage.classList.contains("added_canvas") && canvasContainer) {
        const rect = canvasContainer.getBoundingClientRect();
        width = rect.width;
        height = rect.height;
    } else {
        const img = defaultImage.querySelector("img");
        if (img && img.complete) {
            const rect = defaultImage.getBoundingClientRect();
            width = rect.width;
            height = rect.height;
        } else if (img) {
            img.addEventListener("load", canvasResize, { once: true });
            return;
        }
    }

    if (width > 0 && height > 0) {
        canvas.setWidth(width);
        canvas.setHeight(height);
    }
}

// Run on load
// window.addEventListener("load", canvasResize);

// // Run on resize
// window.addEventListener("resize", () => {
//     requestAnimationFrame(canvasResize);
// });




canvasResize();

function setProductImage(image) {
    canvas.clear();

    window.fabric.Image.fromURL(image, function (img) {
        const scaleRatio = Math.min(canvas.width / img.width, canvas.height / img.height);

        canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
            left: canvas.width / 2,
            top: canvas.height / 2,
            originX: "center",
            originY: "center",
            scaleX: scaleRatio,
            scaleY: scaleRatio,
        });
    });

    const defaultImage = document.querySelector(".product-customizer-wrapper .image-wrapper picture");
    const canvasContainer = document.querySelector(".product-customizer-wrapper .canvas-container");

    if (defaultImage) defaultImage.classList.add("added_canvas");
    if (canvasContainer) canvasContainer.classList.add("added_canvas");

    if (fileInput.value != "" && productSelection.value != "") {
        document.querySelector(".save-image-btn").removeAttribute("disabled")
    }
    canvas.renderAll();
    handleFileUpload("uplodimge1",fileInput,canvas.height / 2 );
}


productSelection.addEventListener("input", function() {
    const selectedOption = this.selectedOptions[0];
    const imageEditor = selectedOption.getAttribute("data-image-editor");
    const heading = selectedOption.getAttribute("data-heading");
    const text = selectedOption.getAttribute("data-text");
    
    canvasResize();
    setProductImage(imageEditor);
    document.querySelector(".text-wrapper h3").innerHTML = heading;
    document.querySelector(".text-wrapper .description-text-wrapper").innerHTML = text;
});




function handleFileUpload(id,thisInput,topToSet) {    
    const fileReader = new FileReader();
    var fileInput = thisInput.files[0];
    if (fileInput){
        document.querySelector(".file_name_place_holder").innerHTML = fileInput.name;
        if (fileInput.value != "" && productSelection.value != "") {
            document.querySelector(".save-image-btn").removeAttribute("disabled")
        }

        fileReader.readAsDataURL(thisInput.files[0])
        fileReader.onload = (e) => {
        const dataURL = e.target.result;
        // $(thisInput).parents(".custom-image-uploader-wrapper").find('input[type="hidden"]').val(dataURL);
        
        var getId = id;
        var objlength = canvas.getObjects();
        if(objlength.length != 0){
            objs = canvas.getObjects();
            objs.forEach(function(obj,value) {
            if (obj && obj.id == getId) {
                setTimeout(function(){
                canvas.remove(obj).renderAll();
                },200);
            }
            });
            canvas.renderAll();
        }
        
            fabric.Image.fromURL(dataURL, function(img) {
            var oImg = img.set({
                id: id,
                left: canvas.width / 2 - canvas.width / 5,
                top: topToSet,
                cornerSize: 20,
            },{
                crossOrigin: 'anonymous'
            }).setCoords();
            oImg.scaleToWidth(canvas.width / 2.5);
            canvas.add(oImg).renderAll();
            canvas.sendToBack(oImg);
            canvas.bringToFront(oImg);
            var objle = canvas.getObjects();
            
            canvas.setActiveObject(canvas.item(objle.length - 1));
            });
            
        }
    }
}

fileInput.addEventListener('change',function() { 
    handleFileUpload("uplodimge1",this,canvas.height / 2 );
});

document.querySelector(".save-image-btn")?.addEventListener("click", function () {
    const canvas = document.getElementById("product-customize-canvas"); // your canvas id

    const link = document.createElement('a');
    link.download = 'canvas-image.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
});
